@if(service.viewDroplistItems.length){
<div class='admissions-prospects-views-part'>

	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'>
	</droplist>

	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.AllProspects) {
	<prospects-all-prospects-view-part></prospects-all-prospects-view-part>
	}
	@case(service.viewId.AllApplications){
	<prospects-all-applications-view-part></prospects-all-applications-view-part>
	}
	@case (service.viewId.ClosedLeads) {
	<prospects-closed-leads-view-part></prospects-closed-leads-view-part>
	}
	}
	}

</div>
}